// Contrats suivis : affichés dans l'objectif en raid. Gardés dans le navigateur (préférence d'affichage).
const KEY = 'zm-track';

export function tracked(): Set<string> {
  try { return new Set(JSON.parse(localStorage.getItem(KEY) ?? '[]') as string[]); } catch { return new Set(); }
}
export function toggleTracked(id: string) {
  const t = tracked();
  if (t.has(id)) t.delete(id); else t.add(id);
  try { localStorage.setItem(KEY, JSON.stringify([...t])); } catch { /* stockage indisponible */ }
  return t.has(id);
}
